var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close",class:[_vm.type],attrs:{"slot":"right"},slot:"right"},[_c('img',{attrs:{"src":`${require('@/assets/image/base/close/' + _vm.logoName)}`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }